<!-- src/components/modal/training-modal.vue -->
<template>
  <!-- Add Training -->
  <div
    class="modal fade"
    id="new_training"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable dq-dialog"
    >
      <div class="modal-content dq-modal-content" :key="addKey">
        <!-- Header -->
        <div class="modal-header dq-modal-header">
          <div class="dq-titlewrap">
            <div class="dq-hero dq-hero-indigo">
              <i class="ti ti-school"></i>
            </div>
            <div>
              <h4 class="modal-title dq-title mb-0">Add Training</h4>
              <div class="dq-subtitle">
                Schedule training, assign employee, and track completion.
              </div>
            </div>
          </div>

          <button
            type="button"
            class="btn-close custom-btn-close dq-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>

        <form @submit.prevent="submitCreate">
          <div class="modal-body dq-modal-body">
            <!-- Tips -->
            <div class="dq-info-row">
              <div class="dq-info-pill">
                <i class="ti ti-search"></i>
                Search Type, Trainer, Employee
              </div>
              <div class="dq-info-pill">
                <i class="ti ti-calendar-event"></i>
                Dates saved as YYYY-MM-DD
              </div>
            </div>

            <!-- Card -->
            <div class="dq-card">
              <div class="dq-card-head">
                <div class="dq-card-title">
                  <i class="ti ti-clipboard-text"></i> Training Details
                </div>
                <div class="dq-card-sub">
                  Choose type, trainer and employee. Add cost and timeline.
                </div>
              </div>

              <div class="row g-3">
                <!-- Training Type (searchable dropdown) -->
                <div class="col-12">
                  <label class="form-label dq-label"
                    >Training Type <span class="text-danger">*</span></label
                  >

                  <div
                    class="dropdown w-100"
                    data-bs-auto-close="outside"
                    data-bs-display="static"
                  >
                    <button
                      class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center dq-dd-btn"
                      type="button"
                      data-bs-toggle="dropdown"
                      @click="openTypeDropdown"
                    >
                      <span class="text-truncate">
                        {{
                          typeSelectedLabel ||
                          (form.training_type_id
                            ? `Type #${form.training_type_id}`
                            : "Select training type")
                        }}
                      </span>
                      <i class="ti ti-chevron-down ms-2"></i>
                    </button>

                    <div class="dropdown-menu p-2 w-100 dq-dd-menu">
                      <input
                        v-model="typeQuery"
                        @input="onTypeInput"
                        type="text"
                        class="form-control dq-input mb-2"
                        placeholder="Search training types…"
                        autocomplete="off"
                      />

                      <div class="dq-search-list">
                        <div
                          v-if="typeLoading"
                          class="text-center py-2 small text-muted"
                        >
                          Loading...
                        </div>

                        <button
                          v-for="opt in typeFiltered"
                          :key="'tt-' + opt.id"
                          type="button"
                          class="dropdown-item dq-dd-item"
                          @click="chooseType(opt)"
                        >
                          <div class="dq-dd-row">
                            <div class="dq-avatar">
                              <i class="ti ti-category"></i>
                            </div>
                            <div class="min-w-0">
                              <div class="dq-dd-title text-truncate">
                                {{ opt.label }}
                              </div>
                              <div class="dq-dd-sub text-truncate">
                                Training Type
                              </div>
                            </div>
                          </div>
                        </button>

                        <div
                          v-if="!typeLoading && typeFiltered.length === 0"
                          class="text-center py-2 small text-muted"
                        >
                          No results
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="dq-help">
                    Tip: type at least 2 characters to fetch more.
                  </div>
                </div>

                <!-- Trainer (searchable dropdown) -->
                <div class="col-12">
                  <label class="form-label dq-label">Trainer</label>

                  <div
                    class="dropdown w-100"
                    data-bs-auto-close="outside"
                    data-bs-display="static"
                  >
                    <button
                      class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center dq-dd-btn"
                      type="button"
                      data-bs-toggle="dropdown"
                      @click="openTrainerDropdown"
                    >
                      <span class="text-truncate">
                        {{
                          trainerSelectedLabel ||
                          (form.trainer_id
                            ? `Trainer #${form.trainer_id}`
                            : "Select trainer")
                        }}
                      </span>
                      <i class="ti ti-chevron-down ms-2"></i>
                    </button>

                    <div class="dropdown-menu p-2 w-100 dq-dd-menu">
                      <input
                        v-model="trainerQuery"
                        @input="onTrainerInput"
                        type="text"
                        class="form-control dq-input mb-2"
                        placeholder="Search trainers…"
                        autocomplete="off"
                      />

                      <div class="dq-search-list">
                        <div
                          v-if="trainerLoading"
                          class="text-center py-2 small text-muted"
                        >
                          Loading...
                        </div>

                        <button
                          v-for="opt in trainerFiltered"
                          :key="'tr-' + opt.id"
                          type="button"
                          class="dropdown-item dq-dd-item"
                          @click="chooseTrainer(opt)"
                        >
                          <div class="dq-dd-row">
                            <div class="dq-avatar">
                              <i class="ti ti-user"></i>
                            </div>
                            <div class="min-w-0">
                              <div class="dq-dd-title text-truncate">
                                {{ opt.label }}
                              </div>
                              <div class="dq-dd-sub text-truncate">Trainer</div>
                            </div>
                          </div>
                        </button>

                        <div
                          v-if="!trainerLoading && trainerFiltered.length === 0"
                          class="text-center py-2 small text-muted"
                        >
                          No results
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="dq-help">
                    Optional: leave empty if internal trainer not assigned.
                  </div>
                </div>

                <!-- Employee (searchable dropdown) -->
                <div class="col-12">
                  <label class="form-label dq-label"
                    >Employee <span class="text-danger">*</span></label
                  >

                  <div
                    class="dropdown w-100"
                    data-bs-auto-close="outside"
                    data-bs-display="static"
                  >
                    <button
                      class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center dq-dd-btn"
                      type="button"
                      data-bs-toggle="dropdown"
                      @click="openEmployeeDropdown"
                    >
                      <span class="text-truncate">
                        {{
                          employeeSelectedLabel ||
                          (form.employee_id
                            ? `Employee #${form.employee_id}`
                            : "Select employee")
                        }}
                      </span>
                      <i class="ti ti-chevron-down ms-2"></i>
                    </button>

                    <div class="dropdown-menu p-2 w-100 dq-dd-menu">
                      <input
                        v-model="employeeQuery"
                        @input="onEmployeeInput"
                        type="text"
                        class="form-control dq-input mb-2"
                        placeholder="Search employees…"
                        autocomplete="off"
                      />

                      <div class="dq-search-list">
                        <div
                          v-if="employeeLoading"
                          class="text-center py-2 small text-muted"
                        >
                          Loading...
                        </div>

                        <button
                          v-for="opt in employeeFiltered"
                          :key="'emp-' + opt.id"
                          type="button"
                          class="dropdown-item dq-dd-item"
                          @click="chooseEmployee(opt)"
                        >
                          <div class="dq-dd-row">
                            <div class="dq-avatar">
                              <i class="ti ti-id"></i>
                            </div>
                            <div class="min-w-0">
                              <div class="dq-dd-title text-truncate">
                                {{ opt.label }}
                              </div>
                              <div class="dq-dd-sub text-truncate">
                                {{ opt.sub || "Employee" }}
                              </div>
                            </div>
                          </div>
                        </button>

                        <div
                          v-if="
                            !employeeLoading && employeeFiltered.length === 0
                          "
                          class="text-center py-2 small text-muted"
                        >
                          No results
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="dq-help">Search by name or employee ID.</div>
                </div>

                <!-- Cost -->
                <div class="col-12">
                  <label class="form-label dq-label">Training Cost</label>
                  <input
                    v-model="form.training_cost"
                    class="form-control dq-input"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="Enter training cost"
                  />
                </div>

                <!-- Dates -->
                <div class="col-12">
                  <label class="form-label dq-label">Training Start Date</label>
                  <date-picker
                    v-model="form.training_start_date"
                    class="form-control datetimepicker dq-input"
                    placeholder="dd/mm/yyyy"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                </div>

                <div class="col-12">
                  <label class="form-label dq-label">Training End Date</label>
                  <date-picker
                    v-model="form.training_end_date"
                    class="form-control datetimepicker dq-input"
                    placeholder="dd/mm/yyyy"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                </div>

                <!-- Description -->
                <div class="col-12">
                  <label class="form-label dq-label">Description</label>
                  <textarea
                    v-model="form.description"
                    class="form-control dq-input"
                    rows="3"
                  ></textarea>
                </div>

                <!-- Status -->
                <div class="col-12">
                  <label class="form-label dq-label">Status</label>
                  <vue-select
                    v-model="form.status"
                    :options="[
                      'Scheduled',
                      'Ongoing',
                      'Completed',
                      'Cancelled',
                    ]"
                    placeholder="Select Status"
                    class="dq-vselect"
                    :clearable="false"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer dq-modal-footer">
            <button
              type="button"
              class="btn dq-btn dq-btn-muted"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>

            <button type="submit" class="btn btn-primary dq-btn dq-btn-primary">
              <span
                v-if="addingTraining"
                class="spinner-border spinner-border-sm me-1"
              ></span>
              Add Training<i class="ti ti-arrow-right ms-2"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Edit Training -->
  <div
    class="modal fade"
    id="edit_training"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable dq-dialog"
    >
      <div class="modal-content dq-modal-content" :key="editKey">
        <!-- Header -->
        <div class="modal-header dq-modal-header">
          <div class="dq-titlewrap">
            <div class="dq-hero dq-hero-amber">
              <i class="ti ti-edit"></i>
            </div>
            <div>
              <h4 class="modal-title dq-title mb-0">Edit Training</h4>
              <div class="dq-subtitle">
                Update assignment, timeline, and progress status.
              </div>
            </div>
          </div>

          <button
            type="button"
            class="btn-close custom-btn-close dq-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>

        <form @submit.prevent="submitEdit">
          <div class="modal-body dq-modal-body">
            <div class="dq-card">
              <div class="dq-card-head">
                <div class="dq-card-title">
                  <i class="ti ti-adjustments"></i> Update Details
                </div>
                <div class="dq-card-sub">
                  Search and update type/trainer/employee quickly.
                </div>
              </div>

              <div class="row g-3">
                <!-- Training Type -->
                <div class="col-12">
                  <label class="form-label dq-label"
                    >Training Type <span class="text-danger">*</span></label
                  >

                  <div
                    class="dropdown w-100"
                    data-bs-auto-close="outside"
                    data-bs-display="static"
                  >
                    <button
                      class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center dq-dd-btn"
                      type="button"
                      data-bs-toggle="dropdown"
                      @click="openTypeDropdown"
                    >
                      <span class="text-truncate">
                        {{
                          typeSelectedLabel ||
                          (form.training_type_id
                            ? `Type #${form.training_type_id}`
                            : "Select training type")
                        }}
                      </span>
                      <i class="ti ti-chevron-down ms-2"></i>
                    </button>

                    <div class="dropdown-menu p-2 w-100 dq-dd-menu">
                      <input
                        v-model="typeQuery"
                        @input="onTypeInput"
                        type="text"
                        class="form-control dq-input mb-2"
                        placeholder="Search training types…"
                        autocomplete="off"
                      />

                      <div class="dq-search-list">
                        <div
                          v-if="typeLoading"
                          class="text-center py-2 small text-muted"
                        >
                          Loading...
                        </div>

                        <button
                          v-for="opt in typeFiltered"
                          :key="'ett-' + opt.id"
                          type="button"
                          class="dropdown-item dq-dd-item"
                          @click="chooseType(opt)"
                        >
                          <div class="dq-dd-row">
                            <div class="dq-avatar">
                              <i class="ti ti-category"></i>
                            </div>
                            <div class="min-w-0">
                              <div class="dq-dd-title text-truncate">
                                {{ opt.label }}
                              </div>
                              <div class="dq-dd-sub text-truncate">
                                Training Type
                              </div>
                            </div>
                          </div>
                        </button>

                        <div
                          v-if="!typeLoading && typeFiltered.length === 0"
                          class="text-center py-2 small text-muted"
                        >
                          No results
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Trainer -->
                <div class="col-12">
                  <label class="form-label dq-label">Trainer</label>

                  <div
                    class="dropdown w-100"
                    data-bs-auto-close="outside"
                    data-bs-display="static"
                  >
                    <button
                      class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center dq-dd-btn"
                      type="button"
                      data-bs-toggle="dropdown"
                      @click="openTrainerDropdown"
                    >
                      <span class="text-truncate">
                        {{
                          trainerSelectedLabel ||
                          (form.trainer_id
                            ? `Trainer #${form.trainer_id}`
                            : "Select trainer")
                        }}
                      </span>
                      <i class="ti ti-chevron-down ms-2"></i>
                    </button>

                    <div class="dropdown-menu p-2 w-100 dq-dd-menu">
                      <input
                        v-model="trainerQuery"
                        @input="onTrainerInput"
                        type="text"
                        class="form-control dq-input mb-2"
                        placeholder="Search trainers…"
                        autocomplete="off"
                      />

                      <div class="dq-search-list">
                        <div
                          v-if="trainerLoading"
                          class="text-center py-2 small text-muted"
                        >
                          Loading...
                        </div>

                        <button
                          v-for="opt in trainerFiltered"
                          :key="'etr-' + opt.id"
                          type="button"
                          class="dropdown-item dq-dd-item"
                          @click="chooseTrainer(opt)"
                        >
                          <div class="dq-dd-row">
                            <div class="dq-avatar">
                              <i class="ti ti-user"></i>
                            </div>
                            <div class="min-w-0">
                              <div class="dq-dd-title text-truncate">
                                {{ opt.label }}
                              </div>
                              <div class="dq-dd-sub text-truncate">Trainer</div>
                            </div>
                          </div>
                        </button>

                        <div
                          v-if="!trainerLoading && trainerFiltered.length === 0"
                          class="text-center py-2 small text-muted"
                        >
                          No results
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Employee -->
                <div class="col-12">
                  <label class="form-label dq-label"
                    >Employee <span class="text-danger">*</span></label
                  >

                  <div
                    class="dropdown w-100"
                    data-bs-auto-close="outside"
                    data-bs-display="static"
                  >
                    <button
                      class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center dq-dd-btn"
                      type="button"
                      data-bs-toggle="dropdown"
                      @click="openEmployeeDropdown"
                    >
                      <span class="text-truncate">
                        {{
                          employeeSelectedLabel ||
                          (form.employee_id
                            ? `Employee #${form.employee_id}`
                            : "Select employee")
                        }}
                      </span>
                      <i class="ti ti-chevron-down ms-2"></i>
                    </button>

                    <div class="dropdown-menu p-2 w-100 dq-dd-menu">
                      <input
                        v-model="employeeQuery"
                        @input="onEmployeeInput"
                        type="text"
                        class="form-control dq-input mb-2"
                        placeholder="Search employees…"
                        autocomplete="off"
                      />

                      <div class="dq-search-list">
                        <div
                          v-if="employeeLoading"
                          class="text-center py-2 small text-muted"
                        >
                          Loading...
                        </div>

                        <button
                          v-for="opt in employeeFiltered"
                          :key="'eemp-' + opt.id"
                          type="button"
                          class="dropdown-item dq-dd-item"
                          @click="chooseEmployee(opt)"
                        >
                          <div class="dq-dd-row">
                            <div class="dq-avatar">
                              <i class="ti ti-id"></i>
                            </div>
                            <div class="min-w-0">
                              <div class="dq-dd-title text-truncate">
                                {{ opt.label }}
                              </div>
                              <div class="dq-dd-sub text-truncate">
                                {{ opt.sub || "Employee" }}
                              </div>
                            </div>
                          </div>
                        </button>

                        <div
                          v-if="
                            !employeeLoading && employeeFiltered.length === 0
                          "
                          class="text-center py-2 small text-muted"
                        >
                          No results
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Cost -->
                <div class="col-12">
                  <label class="form-label dq-label">Training Cost</label>
                  <input
                    v-model="form.training_cost"
                    class="form-control dq-input"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="Enter training cost"
                  />
                </div>

                <!-- Dates -->
                <div class="col-12">
                  <label class="form-label dq-label">Training Start Date</label>
                  <date-picker
                    v-model="form.training_start_date"
                    class="form-control datetimepicker dq-input"
                    placeholder="dd/mm/yyyy"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                </div>

                <div class="col-12">
                  <label class="form-label dq-label">Training End Date</label>
                  <date-picker
                    v-model="form.training_end_date"
                    class="form-control datetimepicker dq-input"
                    placeholder="dd/mm/yyyy"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                </div>

                <!-- Description -->
                <div class="col-12">
                  <label class="form-label dq-label">Description</label>
                  <textarea
                    v-model="form.description"
                    class="form-control dq-input"
                    rows="3"
                  ></textarea>
                </div>

                <!-- Status -->
                <div class="col-12">
                  <label class="form-label dq-label">Status</label>

                  <vue-select
                    v-model="form.status"
                    :options="[
                      'Scheduled',
                      'Ongoing',
                      'Completed',
                      'Cancelled',
                    ]"
                    placeholder="Select Status"
                    class="dq-vselect"
                    :clearable="false"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer dq-modal-footer">
            <button
              type="button"
              class="btn dq-btn dq-btn-muted"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>

            <button
              type="submit"
              class="btn btn-primary dq-btn dq-btn-primary"
              :disabled="!isEdit"
            >
              <span
                v-if="addingTraining"
                class="spinner-border spinner-border-sm me-1"
              ></span>
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Delete Modal -->
  <div class="modal fade" id="delete_modal">
    <div class="modal-dialog modal-dialog-centered modal-md dq-dialog">
      <div class="modal-content dq-modal-content">
        <div class="modal-header dq-modal-header dq-danger-head">
          <div class="dq-titlewrap">
            <div class="dq-hero dq-hero-red"><i class="ti ti-trash"></i></div>
            <div>
              <h4 class="modal-title dq-title mb-0">Confirm Delete</h4>
              <div class="dq-subtitle">This action cannot be undone.</div>
            </div>
          </div>

          <button
            type="button"
            class="btn-close custom-btn-close dq-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>

        <div class="modal-body dq-modal-body">
          <div class="dq-danger">
            <i class="ti ti-alert-triangle"></i>
            <div>
              <div class="dq-danger-title">Delete training record?</div>
              <div class="dq-danger-sub">
                You’re about to permanently remove this training record.
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer dq-modal-footer">
          <button
            type="button"
            class="btn dq-btn dq-btn-muted"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            class="btn btn-danger dq-btn dq-btn-danger"
            :disabled="deleting"
            @click="confirmDelete"
          >
            <span
              v-if="deleting"
              class="spinner-border spinner-border-sm me-1"
            ></span>
            Delete
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch, onMounted, onBeforeUnmount } from "vue";
import { useTrainingStore } from "@/stores/trainingStore";
import { useTrainingTypeStore } from "@/stores/trainingTypeStore";
import { useTrainerStore } from "@/stores/trainerStore";
import { useEmployeeStore } from "@/stores/employeeStore";
import { toast } from "@/utils/toast";

const props = defineProps({
  editItem: { type: Object, default: null },
});
const emit = defineEmits(["saved"]);

const trainStore = useTrainingStore();
const empStore = useEmployeeStore();
const typeStore = useTrainingTypeStore();
const trainerStore = useTrainerStore();

const deleting = ref(false);
const addingTraining = computed(() => trainStore.loading);
const dateFormat = "dd/MM/yyyy";

const addKey = ref(0);
const editKey = ref(0);

const form = ref(blankForm());

function blankForm() {
  return {
    training_type_id: "",
    trainer_id: "",
    employee_id: "",
    training_cost: "",
    training_start_date: null,
    training_end_date: null,
    description: "",
    status: "Scheduled",
  };
}

function resetForm() {
  const blank = blankForm();
  for (const k in blank) form.value[k] = blank[k];
  // clear dropdown labels/queries so UI resets cleanly
  typeQuery.value = "";
  trainerQuery.value = "";
  employeeQuery.value = "";
  typeLabel.value = "";
  trainerLabel.value = "";
  employeeLabel.value = "";
}

/** YYYY-MM-DD (avoid UTC shifting) */
function toYMD(d) {
  if (!d) return null;
  if (typeof d === "string") return d;
  try {
    const dt = new Date(d);
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, "0");
    const day = String(dt.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  } catch {
    return null;
  }
}

/* -------------------- smart fetch helper (like your activity modal) -------------------- */
function debounce(fn, ms = 300) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), ms);
  };
}

async function smartFetch(storeRef, params = {}) {
  const p = {
    q: String(params?.q ?? ""),
    per_page: params?.per_page ?? 20,
    page: params?.page ?? 1,
  };

  // common patterns in your stores
  if (typeof storeRef.fetchAll === "function") {
    await storeRef.fetchAll(p);
    if (storeRef.items && "value" in storeRef.items)
      return storeRef.items.value;
    if (Array.isArray(storeRef.items)) return storeRef.items;
    return [];
  }

  if (typeof storeRef.fetchEmployees === "function") {
    await storeRef.fetchEmployees(p);
    return Array.isArray(storeRef.employees)
      ? storeRef.employees
      : storeRef.employees?.value || [];
  }

  const fn =
    storeRef.list ||
    storeRef.search ||
    storeRef.load ||
    storeRef.fetch ||
    storeRef.index;
  if (!fn) return [];
  const resp = await fn(p);
  const out = resp?.data?.data ?? resp?.data ?? resp ?? [];
  return Array.isArray(out) ? out : [];
}

/* ===================== Training Type searchable dropdown ===================== */
const typeQuery = ref("");
const typeOptions = ref([]);
const typeLoading = ref(false);
const typeLabel = ref("");

const fetchTypes = debounce(async (q = "", perPage = 20) => {
  typeLoading.value = true;
  try {
    const rows = await smartFetch(typeStore, { q, per_page: perPage, page: 1 });
    typeOptions.value = rows
      .filter((t) => t && t.id)
      .map((t) => ({ id: t.id, label: t.type || t.name || `Type #${t.id}` }));
  } finally {
    typeLoading.value = false;
  }
}, 250);

const typeFiltered = computed(() => {
  const q = typeQuery.value.trim().toLowerCase();
  if (!q) return typeOptions.value.slice(0, 8);
  return typeOptions.value.filter((o) =>
    (o.label || "").toLowerCase().includes(q)
  );
});

const typeSelectedLabel = computed(() => {
  const id = form.value.training_type_id;
  if (!id) return "";
  return (
    typeOptions.value.find((o) => o.id === id)?.label || typeLabel.value || ""
  );
});

function openTypeDropdown() {
  fetchTypes("", 8);
}
function onTypeInput() {
  const q = typeQuery.value.trim();
  if (q.length >= 2) fetchTypes(q, 20);
}
function chooseType(opt) {
  form.value.training_type_id = opt.id;
  typeLabel.value = opt.label;
}

/* ===================== Trainer searchable dropdown ===================== */
const trainerQuery = ref("");
const trainerOptions = ref([]);
const trainerLoading = ref(false);
const trainerLabel = ref("");

const fetchTrainers = debounce(async (q = "", perPage = 20) => {
  trainerLoading.value = true;
  try {
    const rows = await smartFetch(trainerStore, {
      q,
      per_page: perPage,
      page: 1,
    });
    trainerOptions.value = rows
      .filter((t) => t && t.id)
      .map((t) => ({
        id: t.id,
        label:
          `${t?.user?.first_name ?? t.first_name ?? ""} ${
            t?.user?.last_name ?? t.last_name ?? ""
          }`.trim() ||
          t.name ||
          `Trainer #${t.id}`,
      }));
  } finally {
    trainerLoading.value = false;
  }
}, 250);

const trainerFiltered = computed(() => {
  const q = trainerQuery.value.trim().toLowerCase();
  if (!q) return trainerOptions.value.slice(0, 8);
  return trainerOptions.value.filter((o) =>
    (o.label || "").toLowerCase().includes(q)
  );
});

const trainerSelectedLabel = computed(() => {
  const id = form.value.trainer_id;
  if (!id) return "";
  return (
    trainerOptions.value.find((o) => o.id === id)?.label ||
    trainerLabel.value ||
    ""
  );
});

function openTrainerDropdown() {
  fetchTrainers("", 8);
}
function onTrainerInput() {
  const q = trainerQuery.value.trim();
  if (q.length >= 2) fetchTrainers(q, 20);
}
function chooseTrainer(opt) {
  form.value.trainer_id = opt.id;
  trainerLabel.value = opt.label;
}

/* ===================== Employee searchable dropdown ===================== */
const employeeQuery = ref("");
const employeeOptions = ref([]);
const employeeLoading = ref(false);
const employeeLabel = ref("");

const fetchEmployees = debounce(async (q = "", perPage = 20) => {
  employeeLoading.value = true;
  try {
    const rows = await smartFetch(empStore, { q, per_page: perPage, page: 1 });
    employeeOptions.value = (rows || [])
      .filter((e) => e && e.id)
      .map((e) => {
        const first = e?.user?.first_name ?? e.first_name ?? "";
        const last = e?.user?.last_name ?? e.last_name ?? "";
        const empId = e.employee_id ? `(${e.employee_id})` : "";
        const dept = e.department?.name || e.department_name || "";
        return {
          id: e.id,
          label: `${first} ${last} ${empId}`.trim() || `Employee #${e.id}`,
          sub: dept ? `Dept: ${dept}` : "",
        };
      });
  } finally {
    employeeLoading.value = false;
  }
}, 250);

const employeeFiltered = computed(() => {
  const q = employeeQuery.value.trim().toLowerCase();
  if (!q) return employeeOptions.value.slice(0, 8);
  return employeeOptions.value.filter((o) =>
    (o.label || "").toLowerCase().includes(q)
  );
});

const employeeSelectedLabel = computed(() => {
  const id = form.value.employee_id;
  if (!id) return "";
  return (
    employeeOptions.value.find((o) => o.id === id)?.label ||
    employeeLabel.value ||
    ""
  );
});

function openEmployeeDropdown() {
  fetchEmployees("", 8);
}
function onEmployeeInput() {
  const q = employeeQuery.value.trim();
  if (q.length >= 2) fetchEmployees(q, 20);
}
function chooseEmployee(opt) {
  form.value.employee_id = opt.id;
  employeeLabel.value = opt.label;
}

/* -------------------- edit sync -------------------- */
watch(
  () => props.editItem,
  async (val) => {
    if (val) {
      form.value.training_type_id = val.training_type_id || "";
      form.value.trainer_id = val.trainer_id || "";
      form.value.employee_id = val.employee_id || "";
      form.value.training_cost = val.training_cost || "";
      form.value.training_start_date = val.training_start_date
        ? new Date(val.training_start_date)
        : null;
      form.value.training_end_date = val.training_end_date
        ? new Date(val.training_end_date)
        : null;
      form.value.description = val.description || "";
      form.value.status = val.status || "Scheduled";

      // prefill labels for nicer UI (no blocking)
      fetchTypes("", 8);
      fetchTrainers("", 8);
      fetchEmployees("", 8);

      editKey.value++;
    } else {
      resetForm();
    }
  },
  { immediate: true }
);

const isEdit = computed(() => !!props.editItem?.id);

/* -------------------- submit -------------------- */
async function submitCreate() {
  if (!form.value.employee_id || !form.value.training_type_id) {
    toast("Employee and Training Type are required", "error");
    return;
  }

  const payload = {
    ...form.value,
    training_start_date: toYMD(form.value.training_start_date),
    training_end_date: toYMD(form.value.training_end_date),
    trainer_id: form.value.trainer_id || null,
    training_cost:
      form.value.training_cost === "" ? null : form.value.training_cost,
  };

  await trainStore.create(payload);
  closeNew();
  resetForm();
  addKey.value++;
  emit("saved");
}

async function submitEdit() {
  if (!props.editItem?.id) return;

  const payload = {
    ...form.value,
    training_start_date: toYMD(form.value.training_start_date),
    training_end_date: toYMD(form.value.training_end_date),
    trainer_id: form.value.trainer_id || null,
    training_cost:
      form.value.training_cost === "" ? null : form.value.training_cost,
  };

  await trainStore.update(props.editItem.id, payload);
  closeEdit();
  resetForm();
  editKey.value++;
  emit("saved");
}

function closeNew() {
  document.querySelector('#new_training [data-bs-dismiss="modal"]')?.click();
}
function closeEdit() {
  document.querySelector('#edit_training [data-bs-dismiss="modal"]')?.click();
}

async function confirmDelete() {
  deleting.value = true;
  try {
    if (!props.editItem?.id) return;
    await trainStore.remove(props.editItem.id);
    emit("saved");
  } finally {
    deleting.value = false;
  }
}

/* -------------------- lifecycle reset -------------------- */
let cleanup = null;

onMounted(async () => {
  // pre-load minimal options so dropdown isn’t empty on first open
  fetchTypes("", 8);
  fetchTrainers("", 8);
  fetchEmployees("", 8);

  const addEl = document.getElementById("new_training");
  const editEl = document.getElementById("edit_training");

  const handleAddShow = () => {
    resetForm();
    addKey.value++;
    fetchTypes("", 8);
    fetchTrainers("", 8);
    fetchEmployees("", 8);
  };
  const handleAddHidden = () => resetForm();

  const handleEditHidden = () => {
    resetForm();
    editKey.value++;
  };

  addEl?.addEventListener("show.bs.modal", handleAddShow);
  addEl?.addEventListener("hidden.bs.modal", handleAddHidden);
  editEl?.addEventListener("hidden.bs.modal", handleEditHidden);

  cleanup = () => {
    addEl?.removeEventListener("show.bs.modal", handleAddShow);
    addEl?.removeEventListener("hidden.bs.modal", handleAddHidden);
    editEl?.removeEventListener("hidden.bs.modal", handleEditHidden);
  };
});

onBeforeUnmount(() => cleanup && cleanup());
</script>

<style scoped>
/* EXACT same design language as promotion-modal */
.dq-dialog {
  max-width: 820px;
}

/* Shell */
.dq-modal-content {
  border-radius: 22px;
  border: none;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.08),
    0 40px 90px rgba(15, 23, 42, 0.14);
}
.dq-modal-header {
  padding: 18px 20px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  background: linear-gradient(180deg, rgba(99, 102, 241, 0.1), #fff);
}
.dq-danger-head {
  background: linear-gradient(180deg, rgba(239, 68, 68, 0.12), #fff);
}
.dq-modal-body {
  padding: 16px 20px;
}

/* Reliable scroll + sticky footer */
.modal-dialog.modal-dialog-scrollable .modal-content {
  max-height: 92vh;
  display: flex;
  flex-direction: column;
}
.modal-dialog.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
  max-height: calc(92vh - 150px);
  overscroll-behavior: contain;
}
.dq-modal-footer {
  padding: 14px 20px;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  background: #fff;
  position: sticky;
  bottom: 0;
  z-index: 2;
}

/* Header */
.dq-titlewrap {
  display: flex;
  align-items: center;
  gap: 12px;
}
.dq-title {
  font-weight: 950;
  letter-spacing: -0.35px;
}
.dq-subtitle {
  font-size: 0.82rem;
  color: rgba(15, 23, 42, 0.6);
}
.dq-close {
  opacity: 0.9;
}
.dq-close:hover {
  opacity: 1;
}

/* Hero */
.dq-hero {
  width: 46px;
  height: 46px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.dq-hero-indigo {
  background: rgba(99, 102, 241, 0.14);
  color: rgb(79, 70, 229);
}
.dq-hero-amber {
  background: rgba(245, 158, 11, 0.14);
  color: rgb(217, 119, 6);
}
.dq-hero-red {
  background: rgba(239, 68, 68, 0.14);
  color: rgb(220, 38, 38);
}

/* Cards */
.dq-card {
  border-radius: 18px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: #fff;
  padding: 14px;
}
.dq-card-head {
  padding: 2px 2px 10px;
}
.dq-card-title {
  font-weight: 950;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.dq-card-sub {
  margin-top: 6px;
  font-size: 0.82rem;
  color: rgba(15, 23, 42, 0.6);
}

/* Tips */
.dq-info-row {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.dq-info-pill {
  flex: 1 1 260px;
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 10px 12px;
  border-radius: 16px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: rgba(15, 23, 42, 0.02);
  color: rgba(15, 23, 42, 0.72);
  font-weight: 800;
  font-size: 0.82rem;
}
.dq-info-pill i {
  color: rgba(99, 102, 241, 0.85);
}

/* Inputs */
.dq-label {
  font-size: 0.82rem;
  font-weight: 900;
}
.dq-input {
  border-radius: 14px;
  padding: 10px 12px;
}
.dq-input:focus {
  border-color: rgba(99, 102, 241, 0.35);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}
.dq-help {
  margin-top: 6px;
  font-size: 0.8rem;
  color: rgba(15, 23, 42, 0.55);
}

/* Dropdown */
.dq-dd-btn {
  border-radius: 14px;
  padding: 10px 12px;
}
.dq-dd-menu {
  border-radius: 16px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.16);
}
.dq-search-list {
  max-height: 280px;
  overflow: auto;
  overscroll-behavior: contain;
}
.dq-dd-item {
  border-radius: 12px;
  padding: 10px 10px;
}
.dq-dd-item:hover {
  background: rgba(15, 23, 42, 0.04);
}
.dq-dd-row {
  display: flex;
  gap: 10px;
  align-items: center;
}
.dq-avatar {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  background: rgba(99, 102, 241, 0.1);
  color: rgb(79, 70, 229);
  display: flex;
  align-items: center;
  justify-content: center;
}
.dq-dd-title {
  font-weight: 900;
}
.dq-dd-sub {
  font-size: 0.78rem;
  color: rgba(15, 23, 42, 0.55);
}

/* Buttons */
.dq-btn {
  border-radius: 12px;
  padding: 10px 16px;
  font-weight: 900;
}
.dq-btn-muted {
  background: rgba(15, 23, 42, 0.04);
  border: 1px solid rgba(15, 23, 42, 0.06);
}
.dq-btn-primary {
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.1);
}
.dq-btn-danger {
  box-shadow: 0 12px 24px rgba(239, 68, 68, 0.12);
}

/* Delete warning */
.dq-danger {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 14px;
  border-radius: 18px;
  border: 1px solid rgba(239, 68, 68, 0.14);
  background: rgba(239, 68, 68, 0.08);
}
.dq-danger i {
  font-size: 18px;
  color: rgb(220, 38, 38);
  margin-top: 2px;
}
.dq-danger-title {
  font-weight: 950;
}
.dq-danger-sub {
  margin-top: 6px;
  font-size: 0.82rem;
  color: rgba(15, 23, 42, 0.7);
}

@media (max-width: 576px) {
  .dq-dialog {
    max-width: 96vw;
    margin: 0.75rem auto;
  }
}
</style>
